import { useMemo, useState } from "react"
import { AdvancedSearch, DatePickerCustom, InputLista, InputNumber } from "../../../components/common"
import InputUsuario from "../../../components/common/InputUsuario"
import Select from "../../../components/common/Select"
import { ESTADOS_FIRMA } from '@laramie/ui';
import { getDateNow } from '../../../utils/convert'

const FirmaDigitalFilters = ({ onSearch, disabled, onOpenUsuario }) => {
    const [inputs, setInputs] = useState({
        idUsuarioSolicitud: 0,
        idEstadoFirma: ESTADOS_FIRMA.PENDIENTE,
        idTipoFirma: 0,
        fechaSolicitudDesde: null,
        fechaSolicitudHasta: null,
        fechaFirmaDesde: null,
        fechaFirmaHasta: null
    })

    const today = useMemo(() => getDateNow(), [])

    const onClickSearch = () => {
        onSearch(inputs)
    }

    return (
        <AdvancedSearch labels={[]} onSearch={onClickSearch}>
            <div className='row form-basic'>
                <div className="col-12 col-md-6">
                    <label htmlFor="idUsuarioSolicitud" className="form-label">Usuario/a solicitud</label>
                    <InputUsuario
                        name="idUsuarioSolicitud"
                        className="form-control"
                        value={inputs.idUsuarioSolicitud}
                        onOpen={onOpenUsuario}
                        onChange={({ target }) => setInputs({...inputs, idUsuarioSolicitud: target.value})}
                    />
                </div>
                <div className="col-12 col-md-3">
                    <label htmlFor="idEstadoFirma" className="form-label">Estado</label>
                    <Select
                        lista="EstadoFirma"
                        name="idEstadoFirma"
                        placeholder="Todos"
                        emptyOption="Todos"
                        className="form-control"
                        value={inputs.idEstadoFirma}
                        onChange={({target}) => setInputs({...inputs, idEstadoFirma: target.value})}
                        disabled={disabled}
                    />
                </div>
                <div className="col-12 col-md-3">
                    <label htmlFor="idTipoFirma" className="form-label">Tipo de documento</label>
                    <InputLista
                        lista="TipoFirma"
                        name="idTipoFirma"
                        placeholder=""
                        textItemZero="Todos"
                        className="form-control"
                        value={inputs.idTipoFirma}
                        onChange={({target}) => setInputs({...inputs, idTipoFirma: target.value})}
                        disabled={disabled}
                    />
                </div>
                <div className="col-12 col-md-6 col-lg-3">
                    <label htmlFor="fechaSolicitudDesde" className="form-label">Fecha solicitud desde</label>
                    <DatePickerCustom
                        name="fechaSolicitudDesde"
                        placeholder=""
                        className="form-control"
                        value={inputs.fechaSolicitudDesde}
                        onChange={({ target }) => setInputs({...inputs, fechaSolicitudDesde: target.value})}
                        disabled={disabled}
                        maxValue={today}
                    />
                </div>
                <div className="col-12 col-md-6 col-lg-3">
                    <label htmlFor="fechaSolicitudHasta" className="form-label">Fecha solicitud hasta</label>
                    <DatePickerCustom
                        name="fechaSolicitudHasta"
                        placeholder=""
                        className="form-control"
                        value={inputs.fechaSolicitudHasta}
                        onChange={({ target }) => setInputs({...inputs, fechaSolicitudHasta: target.value})}
                        minValue={inputs.fechaSolicitudDesde}
                        disabled={disabled}
                        maxValue={today}
                    />
                </div>
                <div className="col-12 col-md-6 col-lg-3">
                    <label htmlFor="fechaFirmaDesde" className="form-label">Fecha firma desde</label>
                    <DatePickerCustom
                        name="fechaFirmaDesde"
                        placeholder=""
                        className="form-control"
                        value={inputs.fechaFirmaDesde}
                        onChange={({ target }) => setInputs({...inputs, fechaFirmaDesde: target.value})}
                        disabled={disabled}
                        maxValue={today}
                    />
                </div>
                <div className="col-12 col-md-6 col-lg-3">
                    <label htmlFor="fechaFirmaHasta" className="form-label">Fecha firma hasta</label>
                    <DatePickerCustom
                        name="fechaFirmaHasta"
                        placeholder=""
                        className="form-control"
                        value={inputs.fechaFirmaHasta}
                        onChange={({ target }) => setInputs({...inputs, fechaFirmaHasta: target.value})}
                        minValue={inputs.fechaFirmaDesde}
                        disabled={disabled}
                        maxValue={today}
                    />
                </div>
            </div>
        </AdvancedSearch>
    )
}

export default FirmaDigitalFilters
